// extracted by mini-css-extract-plugin
module.exports = {"collection-filters-buttons":"update-manage_collection-filters-buttons__EXNnu","collection-filters-action-button":"update-manage_collection-filters-action-button__3CeFD"};